import React from 'react';
import PropTypes from 'prop-types';

import { Typography } from 'components';

function ProfileEducation({ educations }) {
  let keyValue = 0;
  return educations.length === 0
    ? <p className="ProfileEducation ProfileEducation--empty">Sem informações</p>
    : (
      <div className='ProfileEducation'>
        {
          educations.map(education => {
            keyValue++;
            return (
              <div className="profile-education" key={keyValue}>
                <Typography align='left' bold type='paragraph'>
                  {education.school}
                </Typography>
                <Typography align='left' gutterBotton type='paragraph'>
                  {education.course} - {education.startYear}/{education.endYear}
                </Typography>
              </div>
            );
          })
        }
      </div>
    )
}

ProfileEducation.propTypes = { educations: PropTypes.array };

export default ProfileEducation;